import React from "react"
import Text from "components/common/Text"
import Space from "components/common/Space"
import { useTheme } from "styled-components"

const H1 = props => {
  const theme = useTheme()
  return (
    <Space padding="2rem 0px 1rem 0px">
      <Text
        size="xlarge"
        weight="bold"
        lineHeight="small"
        color={theme.colors.accent.primary[500]}
        {...props}
      />
    </Space>
  )
}

export default H1
